import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Clock, Star, BookOpen, Gift, Flower2, Infinity, Brain } from 'lucide-react';
export function Hero() {
  const [timeLeft, setTimeLeft] = useState(30 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const tomos = ['Cuando todo pesa', 'Lo que te cansa y no se ve', 'Soltar la culpa', 'Recuperar sin forzar', 'Que te alcance', 'Hasta el alivio'];
  const bonos = ['Plan Calma sin Culpa', 'Mapa de Fugas Energéticas Invisibles', 'Guía "Cuando todo pesa"'];
  return <>
      {/* Top Offer Banner with Brand */}
      <motion.div className="bg-navy text-cream sticky top-0 z-50 border-b border-warm-gold/20" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-141">
        {/* Brand Row */}
        <div className="py-2 border-b border-warm-gold/10 flex items-center justify-center gap-3" data-id="element-142">
          <div className="relative flex items-center justify-center" data-id="element-143">
            <Infinity className="w-6 h-6 text-warm-gold opacity-90" strokeWidth={1.5} data-id="element-144" />
            <Brain className="w-3 h-3 text-cream absolute" strokeWidth={2} data-id="element-145" />
          </div>
          <span className="font-serif italic text-base md:text-lg text-cream tracking-wide" data-id="element-146">
            InfinitaMenteDigital
          </span>
        </div>
        {/* Offer Row */}
        <div className="py-2 px-4" data-id="element-147">
          <p className="text-xs md:text-sm font-medium flex items-center justify-center gap-2 tracking-wide" data-id="element-148">
            <Clock className="w-3.5 h-3.5 text-warm-gold opacity-90" data-id="element-149" />
            <span className="font-light" data-id="element-150">
              Últimos cupos ·{' '}
              <strong className="font-serif italic text-warm-gold font-normal" data-id="element-151">
                76% OFF
              </strong>{' '}
              por tiempo limitado
            </span>
            <span className="inline-flex items-center bg-warm-gold/10 text-warm-gold rounded-full px-3 py-0.5 font-mono text-sm md:text-base font-medium tabular-nums border border-warm-gold/30" data-id="element-152">
              {String(minutes).padStart(2, '0')}:
              {String(seconds).padStart(2, '0')}
            </span>
          </p>
        </div>
      </motion.div>

      {/* Dreamy Hero with Background Image */}
      <section className="relative overflow-hidden" data-id="element-153">
        {/* Background Image Layer */}
        <div className="absolute inset-0 z-0" data-id="element-154">
          <img src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80" alt="" className="w-full h-full object-cover object-center" aria-hidden="true" data-id="element-155" />
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-cream/60 via-blush/70 to-cream/95" data-id="element-156" />
          <div className="absolute inset-0 bg-gradient-to-r from-dusty-rose/30 via-transparent to-dusty-rose/30" data-id="element-157" />
        </div>

        <div className="relative z-10 pt-8 pb-16 md:pt-12 md:pb-24 px-4 sm:px-6 lg:px-8" data-id="element-158">
          <div className="max-w-4xl mx-auto text-center" data-id="element-159">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            ease: 'easeOut'
          }} data-id="element-160">
              {/* Social Proof */}
              <div className="flex flex-col mb-4 gap-1 items-center scale-[0.69] origin-top" data-id="element-161">
                <div className="flex items-center gap-1.5" data-id="element-162">
                  <div className="flex -space-x-1" data-id="element-163">
                    {[1, 5, 9, 10, 20].map(i => <img key={i} src={`https://i.pravatar.cc/80?img=${i}`} alt="" className="w-5 h-5 rounded-full border border-cream shadow-sm" data-id="element-164" />)}
                  </div>
                  <div className="flex gap-px" data-id="element-165">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 fill-warm-gold text-warm-gold" data-id="element-166" />)}
                  </div>
                </div>
                <p className="font-medium text-navy/70 text-[14px]" data-id="element-167">
                  5/5 · Mujeres reales que ya forman parte de ENERGÍA REAL
                </p>
                <p className="text-navy/50 font-light italic text-[12px]" data-id="element-168"></p>
              </div>

              {/* H1 */}
              <h1 className="md:text-6xl lg:text-[4.5rem] font-serif italic text-navy mb-8 tracking-tight drop-shadow-sm text-[24px]" data-id="element-169">
                ¿Qué pasaría si en 7 días te sacás un peso invisible de encima?
              </h1>

              {/* Pack Premium Highlighted Block */}
              <motion.div className="relative backdrop-blur-sm rounded-2xl border border-dusty-rose/15 shadow-sm px-8 py-4 md:px-10 md:py-5 max-w-sm mx-auto mb-8 overflow-hidden" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.65) 50%, rgba(255,255,255,0.85) 100%)'
            }} initial={{
              opacity: 0,
              y: 15
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3,
              duration: 0.7
            }} data-id="element-170">
                <h2 className="relative text-[#D4836B] font-sans font-extrabold text-lg md:text-xl uppercase tracking-[0.25em]" data-id="element-171">
                  Pack Premium
                </h2>
                <div className="w-10 h-px bg-gradient-to-r from-transparent via-warm-gold/50 to-transparent mx-auto my-2" data-id="element-172" />
                <p className="relative text-navy font-serif italic text-3xl md:text-4xl font-semibold leading-tight" data-id="element-173">
                  Método Energía Real
                </p>
              </motion.div>

              {/* Mockup - between highlighted block and price */}
              <motion.div className="relative max-w-xs mx-auto mb-4 bg-transparent p-0 scale-[0.7] origin-top" style={{
              perspective: 800
            }} initial={{
              opacity: 0,
              scale: 0.65
            }} animate={{
              opacity: 1,
              scale: 0.7
            }} transition={{
              delay: 0.2,
              duration: 0.8,
              ease: 'easeOut'
            }} data-id="element-174">
                <a href="#purchase-section" className="block group cursor-pointer" data-id="element-175">
                  <motion.div className="relative inline-block w-full" animate={{
                  rotateX: [0, 1, 0, -0.5, 0],
                  rotateY: [0, -1, 0, 1, 0]
                }} transition={{
                  rotateX: {
                    duration: 10,
                    repeat: 9999,
                    ease: 'easeInOut'
                  },
                  rotateY: {
                    duration: 12,
                    repeat: 9999,
                    ease: 'easeInOut'
                  }
                }} data-id="element-176">
                    <div className="absolute top-16 right-2 z-10" data-id="element-177">
                      <motion.div className="bg-warm-gold text-white w-14 h-14 md:w-16 md:h-16 rounded-full flex flex-col items-center justify-center shadow-xl border-3 border-cream" animate={{
                      y: [0, -3, 0],
                      scale: [1, 1.02, 1]
                    }} transition={{
                      y: {
                        duration: 5,
                        repeat: 9999,
                        ease: 'easeInOut'
                      },
                      scale: {
                        duration: 6,
                        repeat: 9999,
                        ease: 'easeInOut'
                      }
                    }} data-id="element-178">
                        <span className="text-base md:text-lg font-serif italic leading-none mb-0.5" data-id="element-179">
                          76%
                        </span>
                        <span className="text-[8px] md:text-[10px] font-medium tracking-widest" data-id="element-180">
                          OFF
                        </span>
                      </motion.div>
                    </div>

                    <motion.img src="https://cdn.magicpatterns.com/uploads/tdNCJFkq7xwYvbv1mDyRLE/ChatGPT_Image_11_feb_2026,_04_06_40_p.m._-_Editado.png" alt="Pack Premium Energía Real" className="relative w-full drop-shadow-2xl pt-[-100px] pb-[-100px] mt-[-120px] mb-[-120px]" animate={{
                    y: [0, -6, 0]
                  }} transition={{
                    y: {
                      duration: 6,
                      repeat: 9999,
                      ease: 'easeInOut'
                    }
                  }} whileHover={{
                    scale: 1.03,
                    y: -8,
                    transition: {
                      duration: 0.5,
                      ease: 'easeOut'
                    }
                  }} data-id="element-181" />

                    {/* Animated glow shadow beneath mockup */}
                    <motion.div className="absolute bottom-[-60px] left-1/2 -translate-x-1/2 w-3/4 h-8 rounded-full bg-navy/10 blur-xl pointer-events-none" animate={{
                    scaleX: [1, 0.93, 1],
                    opacity: [0.3, 0.2, 0.3]
                  }} transition={{
                    scaleX: {
                      duration: 6,
                      repeat: 9999,
                      ease: 'easeInOut'
                    },
                    opacity: {
                      duration: 6,
                      repeat: 9999,
                      ease: 'easeInOut'
                    }
                  }} data-id="element-182" />
                  </motion.div>
                </a>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Compact Price and CTA Section */}
      <section className="relative bg-cream py-12 px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-183">
        <div className="max-w-3xl mx-auto" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-185">
            <p className="text-lg md:text-xl text-navy mb-6" data-id="element-186">
              Hoy:{' '}
              <span className="font-serif italic text-warm-gold text-3xl mx-1" data-id="element-187">
                $12.999 ARS
              </span>{' '}
              <strong className="font-bold" data-id="element-188">(76% OFF)</strong>{' '}
              <span className="text-muted italic" data-id="element-189">por tiempo limitado.</span>
            </p>

            <div className="flex flex-col items-center gap-4" data-id="element-190">
              <Button href="https://checkout.infinita-mente.online/checkouts/cn/hWN9k9IdvMh4a0eyG3Ib72tF/es-ar?_r=AQABuGfEX37MTkCup0Rq8tDOnVM70xe0iNj_Nsvx1rNaHiU&preview_theme_id=138558668898" external variant="vibrant" size="xxl" className="w-full sm:w-auto" data-id="element-191">
                QUIERO MI ACCESO INMEDIATO
              </Button>
              <p className="text-xs font-light text-muted tracking-wide italic" data-id="element-192">
                Acceso inmediato · Producto digital · Garantía 7 días
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}